import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OutputDamageData } from '../../@types';
import RecordTable from './RecordTable';
import { selectSelectedClaim } from '../../redux/store/userData/claims/selectors';
import { fetchClaimsByCarId } from '../../redux/store/userData/claims';
import { selectSelectedCar } from '../../redux/store/userData/cars';
import { useIntl } from 'react-intl';

type RecordProps = {
  carRecords: OutputDamageData[];
};

const Record: React.FC<RecordProps> = ({ carRecords }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedClaim = useSelector(selectSelectedClaim);
  const selectedCar = useSelector(selectSelectedCar);
  const selectedCarId = selectedCar?.id;

  useEffect(() => {
    if (selectedCarId) {
      dispatch(fetchClaimsByCarId(selectedCarId));
    }
  }, [selectedCarId, dispatch]);

  return (
    <div className="record-wrapper">
      <RecordTable
        intl={intl}
        rowKey="record"
        dataSource={carRecords}
        selectedId={selectedClaim?.id}
        onClickRow={() => {}}
      />
    </div>
  );
};

export default Record;
